import { HOST } from "../constants/HostConstants";

export const commentReact = async (
  comment_id,
  property_id,
  delta,
  setComments
) => {
  try {
    // Map delta to vote sign for per-user voting: +1 or -1
    const vote = Number(delta) === -1 ? -1 : 1;
    const res = await fetch(`${HOST}/api/comment/commentVote`, {
      method: "POST",
      body: JSON.stringify({ comment_id, property_id, vote }),
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });
    const text = await res.text();
    if (!res.ok) {
return null;
    }
    let data;
    try {
      data = JSON.parse(text);
    } catch (e) {
return null;
    }
    if (setComments) setComments(data);
    return data;
  } catch (err) {
return null;
  }
};
